import { useEffect } from 'react';

type Callback = () => void;

export function useClickOutside(refs: React.RefObject<HTMLElement>[], callback: Callback) {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      setTimeout(() => {
        const isOutside = refs.every(
          (ref) => ref.current && !ref.current.contains(event.target as Node)
        );

        if (isOutside) {
          callback();
        }
      }, 10); // Delay to let inner click handlers run first
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [refs, callback]);
}
